import React from "react";

export default function IndexSectionFeatures12() {
  return (
    <section
      className="relative pt-20 pb-20 lg:pb-32 overflow-hidden"
      id="usecase"
    >
      <img
        className="absolute top-0 right-0"
        src="saturn-assets/images/features/star-element-right.png"
        alt="装飾的な星の要素"
      />
      <div className="relative container px-4 mx-auto">
        <div className="max-w-md lg:max-w-7xl mx-auto">
          <div className="flex flex-wrap -mx-4 mb-18 items-center">
            <div className="w-full lg:w-2/3 xl:w-1/2 px-4 mb-12 lg:mb-0">
              <div className="max-w-lg">
                <span className="inline-block py-1 px-3 mb-4 text-xs font-semibold text-orange-900 bg-orange-50 rounded-full">
                  FEATURES
                </span>
                <h1 className="font-heading text-5xl xs:text-6xl md:text-7xl font-bold text-gray-900">
                  利用事例
                </h1>
              </div>
            </div>
            <div className="w-full lg:w-1/3 xl:w-1/2 px-4">
              <div className="max-w-lg lg:ml-auto">
                <p className="text-lg text-gray-500">
                  私たちのシステムは QR
                  コードに埋め込まれた情報をもとに、さまざまな連携を行うことが可能です。
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap -mx-4">
            <div className="w-full lg:w-1/3 px-4 mb-12 lg:mb-0">
              <div>
                <img
                  className="block mb-6 w-full h-100 rounded-5xl"
                  src="/saturn-assets/images/case-1.avif"
                  alt="塾の入退室管理システムのイメージ"
                />
                <div>
                  <h3 className="text-3xl font-semibold mb-5">
                    生徒の入退室を保護者へ連絡
                  </h3>
                  <span className="text-lg font-semibold">
                    塾へ設置されたスマートフォンを QR
                    コード読み取り機として利用し、入退室を行なった生徒の保護者へメールで連絡するシステムです。
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/3 px-4 mb-12 lg:mb-0">
              <div>
                <img
                  className="block mb-6 w-full h-100 rounded-5xl"
                  src="/saturn-assets/images/case-2.avif"
                  alt="勤怠管理システムのイメージ"
                />
                <div>
                  <h3 className="text-3xl font-semibold mb-5">
                    勤怠システムとの連携
                  </h3>
                  <span className="text-lg font-semibold">
                    社員それぞれに割り当てられたQRコードをかざすと社内の勤怠を連携できます。カードの管理が不要なのでコスト削減につながります。
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/3 px-4">
              <div>
                <img
                  className="block mb-6 w-full h-100 rounded-5xl"
                  src="/saturn-assets/images/case-3.avif"
                  alt="入場管理システムのイメージ"
                />
                <div>
                  <h3 className="text-3xl font-semibold mb-5">
                    入場管理システムとして利用
                  </h3>
                  <span className="text-lg font-semibold">
                    チケット購入者に配布したQRコードで入場管理として利用することができます。読み取った情報から来場率などを計算することもできます。
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
